module.exports = __webpack_public_path__ + "static/media/language-icon.d2febf21.svg";